import axios from "../../../../../axios";
import Cookies from "js-cookie";
import API_BASE_URL from "../../../../config/runtimeConfig";

export const GetAllInterviewScheduleCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetInterviewScheduledCandidates", {
    token,
  });
};

